/**
 * The browser entry point.
 *
 * The only place in the application that registers a service worker, and the
 * only module that touches `virtual:pwa-register` — a module that exists solely
 * inside a Vite build. Everything downstream of here sees a two-method bridge
 * instead (`lib/pwa/updates.ts`), which is what lets the update prompt be
 * tested without a bundler.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { registerServiceWorker } from './lib/pwa/updates.js';
import { useViewStore } from './store/view-store.js';
import './styles/app.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Registered after the first render so a slow worker never delays first paint.
// A build that is waiting reaches the player as a prompt, never as a takeover
// (`offline-delivery` spec, "Explicit update prompt").
void registerServiceWorker({
  onWaiting: (bridge) => {
    useViewStore.getState().updateAvailable(bridge);
  },
});
